// Client-side CSV export helper.
// Usage:
//   downloadCSV("leaderboard.csv",
//     [{ key: "rank", label: "Rank" }, { key: "branch_name", label: "Branch" }, ...],
//     rows);
// A column can also provide `get: (row) => value` for computed cells.

const escapeCell = (v) => {
  const s = v == null ? "" : String(v);
  if (/[",\n\r]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
  return s;
};

export const downloadCSV = (filename, headers, rows) => {
  const headerLine = headers.map((h) => escapeCell(h.label)).join(",");
  const bodyLines = rows.map((row) =>
    headers
      .map((h) => escapeCell(typeof h.get === "function" ? h.get(row) : row[h.key]))
      .join(",")
  );
  const csv = [headerLine, ...bodyLines].join("\r\n");
  const blob = new Blob(["\ufeff", csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};

export const stamp = () => new Date().toISOString().slice(0, 10);
